import React, {ReactElement, ReactNode} from 'react'
import {useConfirm} from "@hooks/alert/useConfirm";
import {Popover} from "@mui/material";
import {useThemeContext} from '@view/theme/context/hooks/useThemeContext';
import {ClosePopoverFeaturesProps, ClosePopoverFn} from "@ui/popover/types";
import IconButtonCustom from "@ui/buttons/iconButtonCustom/IconButtonCustom";
import CloseIcon from '@mui/icons-material/Close';
import {sx} from './sx'

interface IProps {
    children: ReactNode,
    button?: ReactElement,
    anchorPosition?: {
        top: number;
        left: number;
    },
    anchorOrigin?: {
        vertical: 'top' | 'center' | 'bottom' | number;
        horizontal: 'left' | 'center' | 'right' | number;
    },
    confirmMessage?: string,
    hasCloseBtn?:boolean
    /** Fires when the popover opens and closes - lets the caller mark what is being acted on. */
    onOpenChange?: (open: boolean) => void
}

const PopoverComponent = React.forwardRef(({
                                               children,
                                               button,
                                               anchorOrigin,
                                               anchorPosition,
                                               confirmMessage: confirmMessageGlobal,
                                               hasCloseBtn,
                                               onOpenChange,
                                           }: IProps, ref) => {

    const {theme} = useThemeContext()

    const {setConfirm} = useConfirm()
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleOpen = (event?: Event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose: ClosePopoverFn = ({
                                             confirm = true,
                                             confirmMessage: confirmMessageProps,
                                             callback,
                                         }: {
        confirm?: boolean,
        confirmMessage?: string,
        callback?: () => void
    } = {confirm: true}) => {

        if (confirm && (confirmMessageGlobal || confirmMessageProps)) {
            setConfirm({
                message: confirmMessageProps || confirmMessageGlobal,
                callback: () => {
                    if (callback) {
                        callback()
                    }
                    setAnchorEl(null);
                }
            })
            return
        }
        setAnchorEl(null);
    };

    React.useImperativeHandle(ref, () => ({
        closePopover({confirm, confirmMessage, callback}: ClosePopoverFeaturesProps = {}) {
            handleClose({confirm, confirmMessage, callback});
        },

    }), []);
    const open = Boolean(anchorEl);

    React.useEffect(() => {
        onOpenChange?.(open)
    }, [open]);

    return (
        <>
            {React.cloneElement(button, {
                onClick: (event: Event) => {
                    handleOpen(event);
                },

            })}

            {open && <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorPosition={anchorPosition}
                sx={{
                    borderRadius:'6px'
                }}
                anchorOrigin={anchorOrigin || {
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                className={theme === 'dark' ? 'darkTheme' : 'lightTheme'}
            >
                {hasCloseBtn &&  <IconButtonCustom
                    onClick={() => handleClose()}
                    size={'small'}
                    sx={sx.btnClose}
                    color={'#f5f3f0'}
                    variant={'empty'}
                >
                    <CloseIcon fontSize={'small'}/>
                </IconButtonCustom>}


                {children}
            </Popover>}
        </>
    )
});

export default PopoverComponent